import type { TLanguage } from '@common/i18n/definitions'

import { baseGlobals } from '@root/typescript/baseGlobals'

declare const __BACKGROUND_COLOR__: string
declare const __UPDATE_LINK__: string
declare const __LANGUAGE__: TLanguage
declare const __SUBTITLE__: string
declare const __VERSION__: number
declare const __SERVER__: string
declare const __SERIAL__: string
declare const __LANGS__: TLanguage[]
declare const __GROUP__: string
declare const __TITLE__: string

const globals = {
  ...baseGlobals,
  backgroundColor: __BACKGROUND_COLOR__,
  updateLink: __UPDATE_LINK__,
  language: __LANGUAGE__,
  subtitle: __SUBTITLE__,
  version: __VERSION__,
  server: __SERVER__,
  serial: __SERIAL__,
  langs: __LANGS__,
  group: __GROUP__,
  title: __TITLE__
} as const

export default globals
